<button mat-icon-button *ngIf="applications?.length > 0" [matMenuTriggerFor]="headerUserMenu">
  <mat-icon class="header-icon apps-icon" id="thicon">apps</mat-icon>
</button>
<mat-menu #headerUserMenu="matMenu" class="applications-menu" yPosition="below" [overlapTrigger]="false">
  <mat-grid-list cols="3" rowHeight="85px" gutterSize="10px" class="application-grid-list">
    <mat-grid-tile *ngFor="let app of applications" matRipple (click)="switchApp.emit(app)" class="application-card mat-typography">
      <div class="icon-container">
        <img *ngIf="app.imgUrl; else useIcon" src="{{ app.imgUrl }}">
        <ng-template #useIcon>
          <mat-icon class="header-icon apps-icon">{{ app.icon }}</mat-icon>
        </ng-template>
      </div>
      <div class="app-name">{{ app.name | truncate : 32 }}</div>
    </mat-grid-tile>
  </mat-grid-list>
</mat-menu>
